export const orderWorkPending = orders => orders.some(order => order.lookup_pending);
export const storeWorkPending = orders => orders.some(order => order.store_name_pending);

export function storeNamePresentation(order = {}) {
  const state = order.store_name_status?.state;
  const known = typeof order.store_name === 'string' && order.store_name.trim();
  const loading = order.store_name_pending || state === 'loading';
  let notice = '';
  if (state === 'authorization_required') {
    notice = known
      ? '名称暂时无法更新，当前显示上次结果；请联系管理员核查。'
      : '名称暂时无法获取，请联系管理员核查。';
  } else if (state === 'unavailable') {
    notice = known ? '名称暂时无法更新，当前显示上次结果。' : '名称暂时无法获取，请稍后重试。';
  } else if (state === 'stale') {
    notice = '正在更新店铺名称，当前显示上次结果。';
  } else if (state === 'missing') {
    notice = '暂未找到店铺名称，请联系管理员核查。';
  }
  return {
    name: known || (loading ? '店铺名称加载中…' : '店铺名称暂不可用'),
    identifier: order.store_sid ? `店铺编号 ${order.store_sid}` : '',
    notice,
  };
}
